import React from "react";
import HeadLayout from "./HeadLayout";
import HomePage from "../Pages/HomePage";
import AdminRoutes from "../Routes/AdminRoutes";
import AboutUsPage from "../home/AboutPage/AboutUsPage";
import { useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
import ContactUsPage from "../home/ContactPage/ContactUsPage";
import LiveChatProgressPage from "../home/LiveChat/LiveChatProgressPage";
import NavDropComponentPage from "../home/NavComponent/NavDropComponentPage";

import LoginSurukshaPage from "../home/LoginSignup/LoginSurukshaPage";
import SignupSurukshaPage from "../home/LoginSignup/SignupSurukshaPage";
import ForgotPasswordPage from "../home/LoginSignup/ForgetPasswordPage";
import SupportCentrePageFooter from "../Footer/SupportCentre/SupportCentrePageFooter";
import FaqSolvingPage from "../Footer/FAQ'S/FaqSolvingPage";
import PrivacyPolicyPerfectPage from "../Footer/PrivacyPolicy/PrivacyPolicyPerfectPage";
import Footer from "../Footer/BottomFooter/Footer";
import { Routes, Route } from "react-router-dom";
import { CategoryProvider } from "../TopProduct/Context/ProductCategoryContext";
import ProductPage from "../CameraCategory/ProductPage";
import ProductDetails from "../TopProduct/ProductDetails";
import Blog from "../home/Blog";
import Events from "../home/Events";
import PublicPage from "../Dhynamic/PublicPage";
import ProductListing from "../../pages/ProductListing";
import IpNetworkCatalogPage from "../../pages/IpNetworkCatalogPage";
import PrivacyPolicy from "../PrivacyPolicy";
import Projects from "../../pages/Projects";
import Portfolio from "../../pages/Portfolio";
import CityServiceLandingPage from "../../pages/CityServiceLandingPage";
import CaseStudyPage from "../../pages/CaseStudyPage";

import BlogDetails from "../home/BlogDetails";
import EventDetails from "../home/EventDetails";
import Careers from "../../pages/Careers";
import Complaint from "../home/Complain/Complain";

import ClientPage from "../CameraCategorySecondPart/Pages/ClientPage";
import SolutionDetails from "../Solution/Pages/SolutionDetails";
import ServiceDetails from "../../pages/ServiceDetails";
import ProjectDetails from "../../pages/admin/ProjectDetails";
import ProductInquiry from "../home/Complain/ProductInquiry";
import Reviews from "../home/Reviews";
import SolutionsPage from "../Pages/SolutionsPage";
import ServicesPage from "../Pages/ServicesPage";
import TermsAndConditions from "../../pages/TermsAndConditions";

function AdminWrapper() {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith("/admin");
  const legacyRouteRedirect = (basePath) => {
    const remainingPath = location.pathname.replace(/^\/[^/]+/, "");
    return <Navigate to={`${basePath}${remainingPath}`} replace />;
  };

  return (
    <CategoryProvider>
      {!isAdminRoute && <HeadLayout />}
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/admin/*" element={<AdminRoutes />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/complaint" element={<Complaint />} />
        <Route path="/product-inquiry" element={<ProductInquiry />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/blogs" element={<Blog />} />
        {/* <Route path="/events" element={<Events />} /> */}
        <Route path="/live" element={<LiveChatProgressPage />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
        <Route path="/terms" element={<TermsAndConditions />} />
        <Route path="/page/:slug" element={<PublicPage />} />
        <Route
          path="/security-product/category/:categorySlug"
          element={<ProductListing />}
        />
        <Route
          path="/security-product/sub-category/:subCategorySlug"
          element={<ProductListing type="catalog" />}
        />
        <Route path="/security-product" element={<ProductListing />} />
        <Route path="/security-product/brand/:brandSlug" element={<ProductListing />} />
        <Route path="/it-products/category/:categorySlug" element={<ProductListing type="ip-network" />} />
        <Route
          path="/it-products/sub-category/:subCategorySlug"
          element={<ProductListing type="ip-network" />}
        />
        <Route path="/it-products" element={<ProductListing type="ip-network" />} />
        <Route path="/ip-networks" element={legacyRouteRedirect("/it-products")} />
        <Route
          path="/ip-networks/sub-category/:subCategorySlug"
          element={legacyRouteRedirect("/it-products")}
        />
        <Route path="/ip-networks/*" element={legacyRouteRedirect("/it-products")} />
        <Route path="/security-products/*" element={legacyRouteRedirect("/security-product")} />
        <Route path="/products/*" element={legacyRouteRedirect("/security-product")} />
        <Route path="/solutions/:slug" element={<SolutionDetails />} />
        <Route path="/services/:slug" element={<ServiceDetails />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />
        <Route path="/events/:id" element={<EventDetails />} />
        <Route path="/careers" element={<Careers />} />
        <Route
          path="/CameraCategorySecondHome/:category/:id"
          element={<ProductPage />}
        />
        <Route path="/login" element={<LoginSurukshaPage />} />
        <Route path="/forgot-password" element={<ForgotPasswordPage />} />
        <Route path="/support" element={<SupportCentrePageFooter />} />
        <Route path="/faqs" element={<FaqSolvingPage />} />
        <Route path="/policy" element={<PrivacyPolicyPerfectPage />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/projects/:slug" element={<ProjectDetails />} />
        <Route path="/case-study/:slug" element={<CaseStudyPage />} />
        <Route path="/:service/:city" element={<CityServiceLandingPage />} />
        <Route path="/portfolio" element={<Portfolio />} />
        <Route path="/clients" element={<ClientPage />} />
        <Route path="/security-product/:productSlug" element={<ProductDetails />} />
        <Route path="/it-products/:productSlug" element={<ProductDetails />} />
        <Route path="/product/*" element={legacyRouteRedirect("/security-product")} />
        <Route path="/signup" element={<Navigate to="/" replace />} />
        <Route path="/reviews" element={<Reviews />} />
        <Route path="/:id" element={<NavDropComponentPage />} />

        <Route path="/solutions" element={<SolutionsPage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/blogs/:slug" element={<BlogDetails />} />
        </Routes>

      {!isAdminRoute && <Footer />}
    </CategoryProvider>
  );
}

export default AdminWrapper;
